import * as React from 'react';

function SvgYamatoLogoWithTitle(props) {
  return (
    <svg
      width={12572.684}
      height={1500}
      viewBox="0 0 3326.521 396.875"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        style={{
          InkscapeStroke: 'none',
        }}
        d="M396.875 198.438a198.438 198.438 0 01-198.438 198.437A198.438 198.438 0 010 198.437 198.438 198.438 0 01198.438 0a198.438 198.438 0 01198.437 198.438z"
        color="#000"
        fill="#5bad92"
      />
      <path
        style={{
          InkscapeStroke: 'none',
        }}
        d="M171.737 225.114l26.577 46.033 26.577-46.033z"
        color="#000"
        fill="#f9aea5"
      />
      <path
        style={{
          InkscapeStroke: 'none',
        }}
        d="M128.317 218.096l69.997-121.238 69.997 121.238z"
        color="#000"
        fill="#5bad92"
      />
      <path
        style={{
          InkscapeStroke: 'none',
        }}
        d="M58.32 277.872l69.997-121.238 69.997 121.238z"
        color="#000"
        fill="#5bad92"
      />
      <g color="#000">
        <path
          style={{
            InkscapeStroke: 'none',
          }}
          d="M198.314 277.872l69.997-121.238 69.996 121.238z"
          fill="#5bad92"
        />
        <path
          style={{
            InkscapeStroke: 'none',
          }}
          d="M198.314 287.794c-132.21-191.863-66.105-95.931 0 0z"
          fill="#fcfaf2"
        />
      </g>
      <path
        style={{
          InkscapeStroke: 'none',
        }}
        d="M198.314 77.014l-52.254 90.507-17.743-30.73-87.181 151.003H355.493L268.31 136.79l-17.743 30.731zm0 39.688l40.798 70.663-12.014 20.809H169.53l-12.014-20.809zM181.128 267.95H75.506l52.811-91.472 52.811 91.472zm87.183-91.472l52.811 91.472H215.499l52.812-91.472zm-87.324 51.54h34.654l-17.327 30.01z"
        color="#000"
        fill="#fcfaf2"
      />
      <g>
        <path
          d="M448.304 67.907h68.271l55.363 96.399 55.363-96.399h65.61l-93.438 150.714-.105 126.898h-57.521l.104-128.03zM671.542 206.713q6.6-42.811 28.855-57.144 22.254-14.522 60.916-14.522 39.04 0 61.67 14.71 22.632 14.71 22.632 44.132v110.139q0 28.478 11.881 33.193v8.298h-59.218q-3.584-10.184-5.092-23.197v-1.698q-25.65 30.175-64.688 30.175-27.158 0-45.452-15.087-18.293-15.276-18.293-44.886 0-56.201 59.407-64.876l48.469-7.356q18.86-2.828 18.86-17.162 0-23.385-33.005-23.385-18.293 0-25.46 7.166-7.167 7.167-9.053 21.5zm119.946 39.416q-5.469 3.96-16.03 6.79-10.373 2.829-20.368 4.337-16.408 2.263-26.404 8.864-9.807 6.413-9.807 21.123 0 13.013 7.167 18.86 7.167 5.846 19.237 5.846 18.86 0 32.438-11.693 13.767-11.693 13.767-28.1zm-27.346-132.205zm36.965 231.595zM881.304 140.328h51.675v30.93q21.123-36.211 60.917-36.211 22.442 0 35.455 9.43 13.202 9.43 20.934 23.763 19.237-33.193 56.767-33.193 30.93 0 50.355 18.294 19.425 18.293 19.425 49.977v142.2h-54.126V221.047q0-40.548-31.118-40.548-35.456 0-35.456 41.868V345.52h-54.127V222.366q0-23.574-7.544-32.627-7.355-9.24-24.706-9.24-34.324 0-34.324 39.981V345.52h-54.127zM1210.872 206.713q6.6-42.811 28.855-57.144 22.254-14.522 60.916-14.522 39.04 0 61.67 14.71 22.632 14.71 22.632 44.132v110.139q0 28.478 11.881 33.193v8.298h-59.219q-3.583-10.184-5.092-23.197v-1.698q-25.648 30.175-64.688 30.175-27.157 0-45.45-15.087-18.295-15.276-18.295-44.886 0-56.201 59.408-64.876l48.469-7.356q18.859-2.828 18.859-17.162 0-23.385-33.004-23.385-18.294 0-25.46 7.166-7.167 7.167-9.053 21.5zm119.946 39.416q-5.47 3.96-16.03 6.79-10.373 2.829-20.369 4.337-16.407 2.263-26.403 8.864-9.807 6.413-9.807 21.123 0 13.013 7.167 18.86 7.166 5.846 19.236 5.846 18.86 0 32.439-11.693 13.767-11.693 13.767-28.1zm-27.346-132.205zm36.964 231.595zM1409.565 178.612v-38.284h27.912V86.012h54.127v54.316h33.193v38.284h-33.193v112.214q0 11.316 4.338 13.956 4.526 2.64 18.67 2.64 4.904 0 10.75-.565v41.302q-15.653.566-27.157.566-36.21 0-48.47-9.996-12.258-9.995-12.258-34.512V178.612zm68.083 166.907zM1536.005 242.923q0-49.6 28.855-78.644 28.855-29.232 76.004-29.232 44.885 0 74.872 28.1 29.987 28.101 29.987 79.776 0 47.715-27.912 77.89-27.913 29.986-76.947 29.986-45.074 0-75.06-28.1-29.799-28.29-29.799-79.776zm55.824.566q0 62.425 49.035 62.425 49.034 0 49.034-62.425t-49.034-62.425q-49.035 0-49.035 62.425zm49.79-129.565zM1874.394 67.907h125.604q41.49 0 63.556 24.329 22.254 24.14 22.254 62.425 0 41.302-24.328 66.197-24.14 24.894-63.368 24.894h-66.197v99.767h-57.521zm57.521 48.658v80.53h52.995q42.434 0 42.434-41.491 0-22.443-12.447-30.741-12.447-8.298-37.908-8.298zM2110.852 345.519V140.328h51.675v37.153q11.504-23.386 24.706-32.816 13.202-9.618 33.193-9.618 2.64 0 10.938.565v54.881q-8.11-.565-13.956-.565-52.43 0-52.43 48.657V345.52zm63.557-231.595zm-37.154 231.595zM2243.15 242.923q0-49.6 28.854-78.644 28.855-29.232 76.004-29.232 44.886 0 74.872 28.1 29.987 28.101 29.987 79.776 0 47.715-27.912 77.89-27.912 29.986-76.947 29.986-45.074 0-75.06-28.1-29.799-28.29-29.799-79.776zm55.823.566q0 62.425 49.035 62.425t49.035-62.425q0-62.425-49.035-62.425t-49.035 62.425zm49.79-129.565zM2467.114 178.612v-38.284h27.912V86.012h54.127v54.316h33.193v38.284h-33.193v112.214q0 11.316 4.338 13.956 4.526 2.64 18.67 2.64 4.904 0 10.75-.565v41.302q-15.653.566-27.157.566-36.21 0-48.469-9.996-12.259-9.995-12.259-34.512V178.612zm68.083 166.907zM2593.554 242.923q0-49.6 28.855-78.644 28.855-29.232 76.004-29.232 44.886 0 74.872 28.1 29.987 28.101 29.987 79.776 0 47.715-27.912 77.89-27.912 29.986-76.947 29.986-45.074 0-75.06-28.1-29.799-28.29-29.799-79.776zm55.824.566q0 62.425 49.035 62.425t49.035-62.425q0-62.425-49.035-62.425t-49.035 62.425zm49.79-129.565zM2955.183 269.326h55.824q-6.035 38.85-29.61 60.162-23.574 21.311-64.688 21.311-42.81 0-68.648-26.026-25.649-26.214-25.649-78.455 0-49.978 24.329-80.53 24.328-30.741 72.986-30.741 36.587 0 61.293 18.86 24.895 18.67 29.987 59.595h-55.824q-2.83-13.767-10.75-23.008-7.733-9.43-23.197-9.43-43 0-43 64.31 0 60.54 40.36 60.54 15.087 0 25.837-10.562 10.75-10.56 10.75-26.026zm-34.702-155.402zm-3.017 231.595zM3030.147 242.923q0-49.6 28.855-78.644 28.855-29.232 76.004-29.232 44.885 0 74.872 28.1 29.986 28.101 29.986 79.776 0 47.715-27.912 77.89-27.912 29.986-76.946 29.986-45.074 0-75.06-28.1-29.799-28.29-29.799-79.776zm55.824.566q0 62.425 49.035 62.425 49.034 0 49.034-62.425t-49.034-62.425q-49.035 0-49.035 62.425zm49.79-129.565zM3272.395 345.519V67.907h54.127V345.52zm27.158-298.734zm0 298.734z"
          style={{
            lineHeight: 1.25,
            InkscapeFontSpecification: "'Helvetica, Bold'",
          }}
          fontWeight={700}
          fontSize={36.547}
          fontFamily="Helvetica"
          letterSpacing={-0.669}
          wordSpacing={0}
          fill="#5bad92"
        />
        <path
          style={{
            InkscapeStroke: 'none',
          }}
          d="M516.575 67.907h110.726l-55.363 96.399z"
          color="#000"
          fill="#fcfaf2"
        />
        <path d="M548.003 86.148h47.87l-23.935 41.676z" fill="#f9aea5" />
      </g>
    </svg>
  );
}

export default SvgYamatoLogoWithTitle;
